module.exports = __webpack_public_path__ + "static/img/logo.34decc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_spin/logo.png
// module id = hv2h
// module chunks = 4